/*
Looking to add a new experiment?
Read this - https://github.com/wix-private/wix-answers/blob/master/answers-client/core/experiments/README.md
*/
export var featureToggleMap = {
    BobSnippet: {
        petriSpec: 'specs.EnableBobSnippet',
        default: false,
        description: 'Will add a new special Bob snippet in call center insights',
        mergeJira: 'TBD'
    },
    UseWixRecorder: {
        petriSpec: 'specs.UseWixRecorder',
        default: false,
        description: 'Enables user session recording',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12045'
    },
    SingleSelectV3: {
        petriSpec: 'specs.SingleSelectV3',
        default: false,
        description: 'Enables Single Select V3',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12045'
    },
    ArticlesBulkActions: {
        petriSpec: 'specs.ArticlesBulkActions',
        default: false,
        description: 'Will show bulk actions of article list when select articles',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9490'
    },
    WidgetDraggable: {
        petriSpec: 'specs.EnableWidgetDraggable',
        default: false,
        description: 'Enables Widget V3 draggable feature',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9473'
    },
    WidgetIconMsg: {
        petriSpec: 'specs.EnableWidgetIconMsg',
        default: false,
        description: 'Enables Widget V3 icon msg settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9615'
    },
    WidgetChatbot: {
        petriSpec: 'specs.WidgetChatbot',
        default: false,
        description: 'Enables Chatbot in Widget V3',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10793'
    },
    SlaPolicies: {
        petriSpec: 'specs.SlaPolicies',
        default: false,
        description: 'Enables SLA',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9712'
    },
    CustomFields: {
        petriSpec: 'specs.CustomFields',
        default: false,
        description: 'New Custom Fields Customers / Tickets',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9713'
    },
    ChatDevice: {
        petriSpec: 'specs.ChatDevice',
        default: false,
        description: 'Adds Chat Device to App for AutoAssign feature',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9978'
    },
    GlobalStatus: {
        petriSpec: 'specs.GlobalStatus',
        default: false,
        description: 'New Agent Global Status',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9979'
    },
    ChatAutoAssign: {
        petriSpec: 'specs.ChatAutoAssign',
        default: false,
        description: 'Chat Auto Assign settings page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10093',
    },
    EnableMacros: {
        petriSpec: 'specs.EnableMacros',
        default: false,
        description: 'enables macros on tickets settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10432'
    },
    NewUpgradeFlow: {
        petriSpec: 'specs.NewUpgradeFlow',
        default: false,
        description: 'enables the new upgrade flow and the new package picker for Answers Premium',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10477'
    },
    HelpcenterSettingsV2: {
        petriSpec: 'specs.HelpcenterSettingsV2',
        default: false,
        description: 'enables helpcenter settings V2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10669'
    },
    CallDelay: {
        petriSpec: 'specs.CallDelay',
        default: false,
        description: 'Enables call delay option for agents',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10946'
    },
    CustomFieldsLimit: {
        petriSpec: 'specs.CustomFieldsLimit',
        default: false,
        description: 'Increases custom fields limits',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11019'
    },
    AutoCollapseOnSearch: {
        petriSpec: 'specs.AutoCollapseOnSearch',
        default: false,
        description: 'Article viewer collapsible auto collapse on cmd+f',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11103'
    },
    ChatArticleSuggestions: {
        petriSpec: 'specs.ChatArticleSuggestions',
        default: false,
        description: 'enables article suggestions in chat reply',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11256',
    },
    FinnishSupportedLang: {
        petriSpec: 'specs.FinnishSupportedLang',
        default: false,
        description: 'Shows Finnish as support lang',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11255'
    },
    CompactCallDevice: {
        petriSpec: 'specs.CompactCallDevice',
        default: false,
        description: 'Call Device redesign',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11304'
    },
    ChatHotkeys: {
        petriSpec: 'specs.ChatHotkeys',
        default: false,
        description: 'Enables hotkeys for Chat Jira: WA-11436',
        mergeJira: 'TBD'
    },
    ChatReplyAndGo: {
        petriSpec: 'specs.ChatReplyAndGo',
        default: false,
        description: 'Agent reply and go to next chat',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11443'
    },
    WhatsappAttachments: {
        petriSpec: 'specs.WhatsappAttachments',
        default: false,
        description: 'Enables Whatsapp attachments from the App to Whatsapp',
        mergeJira: 'TBD - internal'
    },
    LowCreditBlock: {
        petriSpec: 'specs.LowCreditBlock',
        default: false,
        description: 'Blocks reply area when the account is low on credits.',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12460'
    },
    RemoveCreditBlock: {
        petriSpec: 'specs.RemoveCreditBlock',
        default: false,
        description: 'Removes Ticket Page block when credits are insufficient.',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12357'
    },
    UploadZipFiles: {
        petriSpec: 'specs.UploadZipFiles',
        default: false,
        description: 'Enables uploading zip files (made for MH)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12135'
    },
    DashboardOutboundCallsAndTotalTime: {
        petriSpec: 'specs.DashboardOutboundCallsAndTotalTime',
        default: false,
        description: 'Patch for outbound sales MH account (and others) to include outbound calls to dashboard without adding filters to the UI. This also adds a "total call time" in the agents table',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12295'
    },
    TicketsListNewPresenceComponent: {
        petriSpec: 'specs.TicketsListNewPresenceComponent',
        default: false,
        description: 'Enables new ticket list presence design',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12391',
    },
    SlaSettingsV2: {
        petriSpec: 'specs.SlaSettingsV2',
        default: false,
        description: 'Enables SLA settings v2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12461'
    },
    EditCategoryIconSrc: {
        petriSpec: 'specs.EditCategoryIconSrc',
        default: false,
        description: 'Allows editing of category icon by source only, while keeping the icon key. Needed for new HC',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12515'
    },
    AnswersEnableChatWebhooksDigibankPOC: {
        petriSpec: 'specs.AnswersEnableChatWebhooksDigibankPOC',
        default: false,
        description: 'Enables chat webhooks for digibank POC - client and server',
        mergeJira: 'https://jira.wixpress.com/browse/WONT-BE-MERGED'
    },
    ControlRoom: {
        petriSpec: 'specs.ControlRoom',
        default: false,
        description: 'Control room page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12754'
    },
    ExtendFacebookReplyPeriod: {
        petriSpec: 'specs.ExtendFacebookReplyPeriod',
        default: false,
        description: 'Extends Facebook\'s 7 days to reply period to 21 days',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12760'
    },
    OneInbox: {
        petriSpec: 'specs.OneInbox',
        default: false,
        description: 'One Inbox page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12763'
    },
    CompanyFieldsM5: {
        petriSpec: 'specs.CompanyFieldsM5',
        default: false,
        description: 'Enables company fields and new ticket/customer fields in ticket page side bar',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13081',
    },
    AdvancedReportsWasabi: {
        petriSpec: 'specs.AdvancedReportsWasabi',
        default: false,
        description: 'wasabi insights reports',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13148'
    },
    CallTypeIndicator: {
        petriSpec: 'specs.CallTypeIndicator',
        default: false,
        description: 'add a call type column to call center',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13463'
    },
    WorkflowsBetaScenarios: {
        petriSpec: 'specs.WorkflowsBetaScenarios',
        default: false,
        description: 'Opening this experiment enables spotter scenarios that are still in dev',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14377'
    },
    AutoRouting: {
        petriSpec: 'specs.AutoRouting',
        default: false,
        description: 'helpdesk auto routing',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13513'
    },
    NewAgentStatus: {
        petriSpec: 'specs.NewAgentStatus',
        default: false,
        description: 'Global Agent status V3',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13767'
    },
    AutoRoutingDevice: {
        petriSpec: 'specs.AutoRoutingDevice',
        default: false,
        description: 'New push notifications device',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13911'
    },
    CCAccountManager: {
        petriSpec: 'specs.CcAccountManager',
        default: false,
        description: 'Dynamically cc the associated account manager',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14114'
    },
    OutboundChat: {
        petriSpec: 'specs.OutboundChat',
        default: false,
        description: 'Enables the option to open an outbound chat',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14070'
    },
    NewTicketModal: {
        petriSpec: 'specs.NewTicketModal',
        default: false,
        description: 'renders the new refactored ticket modal',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14131'
    },
    Partners: {
        petriSpec: 'specs.EnablePartners',
        default: false,
        description: 'enables partner users in app',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14133'
    },
    ForceHotjarTracking: {
        petriSpec: 'specs.ForceHotjarTracking',
        default: false,
        description: 'forces hotjar tracking',
        mergeJira: 'should never be merged'
    },
    JiraIntegrationV2: {
        petriSpec: 'specs.JiraIntegrationV2',
        default: false,
        description: 'enables new features for Jira Integration',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14172'
    },
    NewBusyStatus: {
        petriSpec: 'specs.NewBusyStatus',
        default: false,
        description: 'move custom statuses to account settinga',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14208'
    },
    ReplyBoxShowAllEmojis: {
        petriSpec: 'specs.ReplyBoxShowAllEmojis',
        default: false,
        description: 'does not limit emojis shown in reply box (WA-13278)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14176'
    },
    CustomCompanyFieldsFilters: {
        petriSpec: 'specs.CustomCompanyFieldsFilters',
        default: false,
        description: 'Enables custom company fields in One Inbox Views',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14413'
    },
    JiraIntegrationSettingsV2: {
        petriSpec: 'specs.JiraIntegrationSettingsV2',
        default: false,
        description: 'https://jira.wixpress.com/browse/WA-14411'
    },
    NewLinesSettingsTable: {
        petriSpec: 'specs.NewLinesSettingsTable',
        default: false,
        description: 'New line settings table',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14635'
    },
    AgentLocaleInterfacePicker: {
        petriSpec: 'specs.AgentLocaleInterfacePicker',
        default: false,
        description: 'Enables agent locale interface picker from user editor',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14721'
    },
    HC2DetailedList: {
        petriSpec: 'specs.HC2DetailedList',
        default: false,
        description: 'Enables Detailed List layout for categories section in HCv2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14731'
    },
    HC2SectionsCodeOverrides: {
        petriSpec: 'specs.HC2SectionsCodeOverrides',
        default: false,
        description: 'Enables code overrides for all sections in HCv2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14769'
    },
    APIReactQuery: {
        petriSpec: 'specs.AnswersAPIReactQuery',
        default: false,
        description: 'Wraps the API layer with React Query',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14859'
    },
    OneInboxCache: {
        petriSpec: 'specs.AnswersOneInboxCache',
        default: false,
        description: 'Enables the cache layer for OneInbox',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15339'
    },
    HC2CustomSection: {
        petriSpec: 'specs.HC2CustomSection',
        default: false,
        description: "adds ability to add a custom section to tenant's helpcenter v2",
        mergeJira: 'https://jira.wixpress.com/browse/WA-15043'
    },
    HC2ArticleInfo: {
        petriSpec: 'specs.HC2ArticleInfo',
        default: false,
        description: 'Enables settings for article info in article pages in HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15054'
    },
    ChatbotBuilderPOC: {
        petriSpec: 'specs.ChatbotBuilderPOC',
        default: false,
        description: 'POC of chatbot builder',
        mergeJira: 'Wont merge'
    },
    WasabiMocks: {
        petriSpec: 'specs.WasabiMocks',
        default: false,
        description: 'wasabi mock reports for marketing use',
        mergeJira: 'wont merge'
    },
    WorkflowsBetaConditions: {
        petriSpec: 'specs.WorkflowsBetaConditions',
        default: false,
        description: 'Hides spotter conditions that did not go through QA',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15171'
    },
    NewAgentModal: {
        petriSpec: 'specs.NewAgentModal',
        default: false,
        description: 'new agent modal with control room/auto routing/ global status additions',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15223'
    },
    LogDuplexerMessages: {
        petriSpec: 'specs.LogDuplexerMessages',
        default: false,
        description: 'logs all duplexer messages for debug purposes',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15401'
    },
    HC2CategoryImageScale: {
        petriSpec: 'specs.HC2CategoryImageScale',
        default: false,
        description: 'Enables support for scale category image in HC2 settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15444'
    },
    CallcenterLogs: {
        petriSpec: 'specs.CallcenterLogs',
        default: false,
        description: 'enables debug logs for callcenter',
        mergeJira: 'TBD'
    },
    CallCenterRemoveDelays: {
        petriSpec: 'specs.CallCenterRemoveDelays',
        default: false,
        description: 'removes delays for stop polling in callcenter',
        mergeJira: 'TBD'
    },
    HCNextPrevArticle: {
        petriSpec: 'specs.HCNextPrevArticle',
        default: false,
        description: 'enables settings for next prev buttons',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15470'
    },
    KnowledgeBaseComments: {
        petriSpec: 'specs.KnowledgeBaseComments',
        default: false,
        description: 'Comments in Answers KB',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15396'
    },
    HC2HeroSideBySide: {
        petriSpec: 'specs.HC2HeroSideBySide',
        default: false,
        description: 'enables side-by-side layout in top-section HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15611'
    },
    DisableMobileLock: {
        petriSpec: 'specs.DisableMobileLock',
        default: false,
        description: 'disables mobile lock',
        mergeJira: 'TBD'
    },
    HC2CategoriesColumns: {
        petriSpec: 'specs.HC2CategoriesColumns',
        default: false,
        description: 'Adds support for items per row settings in categories pages HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15659'
    },
    ImageComponentWidth: {
        petriSpec: 'specs.ImageComponentWidth',
        default: false,
        description: 'Enables 100% max width for image in image-component',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15709'
    },
    OneInboxChatStats: {
        petriSpec: 'specs.OneInboxChatStats',
        default: false,
        description: 'Enables Chat Stats in OI, requested by WIX',
        mergeJira: 'TBD'
    },
    ShowOneInboxVideo: {
        petriSpec: 'specs.ShowOneInboxVideo',
        default: false,
        description: 'Shows one inbox video on first time usage',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15725'
    },
    HC2AllLevelsDetailedList: {
        petriSpec: 'specs.HC2AllLevelsDetailedList',
        default: false,
        description: 'Enables all levels detailed list layout for categories in HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15780'
    },
    MultiBrand: {
        petriSpec: 'specs.MultiBrand',
        default: false,
        description: 'MultiBrand FT',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15799'
    },
    HCSidebarNavigation: {
        petriSpec: 'specs.SidebarNavigation',
        default: false,
        description: 'HC Sidebar Navigation',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15577'
    },
    SlaInsightsV2: {
        petriSpec: 'specs.SlaInsightsV2',
        default: false,
        description: 'enables the sla insights v2 inside new ticket insights',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15860'
    },
    FreeTrialHelpWidget: {
        petriSpec: 'specs.FreeTrialHelpWidget',
        default: false,
        description: 'Free Trial Help Widget',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15770'
    },
    OneInboxChatSoundNotification: {
        petriSpec: 'specs.OneInboxChatSoundNotification',
        default: false,
        description: 'Play sound notification when there is a new chat in One Inbox',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15985'
    },
    QueuePriority: {
        petriSpec: 'specs.QueuePriority',
        default: false,
        description: 'queue priority FT',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15929'
    },
    CustomerPortalSettings: {
        petriSpec: 'specs.CustomerPortalSettings',
        default: false,
        description: 'Customer portal settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15991'
    },
    AutoRoutingBrowserNotifications: {
        petriSpec: 'specs.AutoRoutingBrowserNotifications',
        default: false,
        description: 'enables auto routing browser notifications',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15995'
    },
    OneInboxChatStatusFilter: {
        petriSpec: 'specs.OneInboxChatStatusFilter',
        default: false,
        description: 'add filter by chat status to OI',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15979'
    },
    HC2NewCustomFontSettings: {
        petriSpec: 'specs.HC2NewCustomFontSettings',
        default: false,
        description: 'enables new external custom font settings in HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16117'
    },
    RemoveRedundantFlowsCC: {
        petriSpec: 'specs.RemoveRedundantFlowsCC',
        default: false,
        description: 'Removes redundant flows in Call center, this FT will help on removing this flows',
        mergeJira: 'TBD'
    },
    FacebookIndicationOnTicketPage: {
        petriSpec: 'specs.FacebookIndicationOnTicketPage',
        default: false,
        description: 'Add Facebook indication on ticket page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16125'
    },
    EmailOpenIndication: {
        petriSpec: 'specs.EmailOpenIndication',
        default: false,
        description: 'adds sent and read indication for agent replies',
        mergeJira: 'TBD'
    },
    PositionInLine: {
        petriSpec: 'specs.PositionInLine',
        default: false,
        description: 'shows position in line in chat widget + chat settings page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16149'
    },
    Schedules: {
        petriSpec: 'specs.Schedules',
        default: false,
        description: 'enables new schedules page and app menu item',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16186'
    },
    FacebookRepliesTextFormatting: {
        petriSpec: 'specs.FacebookRepliesTextFormatting',
        default: false,
        description: 'format Facebook replies',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16289'
    },
    SpotterPopoverSelector: {
        petriSpec: 'specs.SpotterPopoverSelector',
        default: false,
        description: 'Spotter popover selector FT',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16292'
    },
    ContextualArticlesInAnswersWidget: {
        petriSpec: 'specs.ContextualArticlesInAnswersWidget',
        default: false,
        description: 'Add contextual articles to wixanswers widget',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15771'
    },
    EndChat: {
        petriSpec: 'specs.EndChat',
        default: false,
        description: 'new end chat flow',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16377'
    },
    CompanyDefaultPermission: {
        petriSpec: 'specs.CompanyDefaultPermission',
        default: false,
        description: 'allows edit company default permission',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16424'
    },
    CallCenterDashboard: {
        petriSpec: 'specs.CallCenterDashboard',
        default: false,
        description: 'Enables new Call Center Dashboard',
        mergeJira: ''
    },
    CallCenterDashboardAgents: {
        petriSpec: 'specs.CallCenterDashboardAgents',
        default: false,
        description: 'Enables new Call Center Dashboard Agents Tab',
        mergeJira: ''
    },
    UseGoogleFontCdn: {
        petriSpec: 'specs.UseGoogleFontCdn',
        default: false,
        description: 'uses google font cdn for fira sans with specific font weights',
        mergeJira: ''
    },
    PaymentDetails: {
        petriSpec: 'specs.PaymentDetails',
        default: false,
        description: 'Enables Payment and Billing details',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16674'
    },
    UpdateUserCompaniesPermissions: {
        petriSpec: 'specs.UpdateUserCompaniesPermissions',
        default: false,
        description: 'Update user companies permissions',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16824'
    },
    WasabiCustomReports: {
        petriSpec: 'specs.WasabiCustomReports',
        default: false,
        description: 'enables WASABI custom reports',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16862'
    },
    RoutingDeviceWorkloadFix: {
        petriSpec: 'specs.RoutingDeviceWorkloadFix',
        default: false,
        description: 'fixes multi workload routing issue',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16993'
    },
    WidgetDelayEndHourForActiveChats: {
        petriSpec: 'specs.WidgetDelayEndHourForActiveChats',
        default: false,
        description: 'delay end of working hours for green invoice',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16838'
    },
    LoggingACall: {
        petriSpec: 'specs.LoggingACall',
        default: false,
        description: 'Logging a Call feature for answers app (internal notes + custom fields)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17013'
    },
    SpotterEndChatAction: {
        petriSpec: 'specs.SpotterEndChatAction',
        default: false,
        description: 'new end chat action',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17142'
    },
    SpotterReplyTypeTrigger: {
        petriSpec: 'specs.SpotterReplyTypeTrigger',
        default: false,
        description: 'add new reply type trigger for existing scenarios',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17162'
    },
    RealtimeTicketsPresence: {
        petriSpec: 'specs.RealtimeTicketsPresence',
        default: false,
        description: 'tickets RT presence',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17013'
    },
    HelpcenterSdkAddOnContactForm: {
        petriSpec: 'specs.HCOnContactFormRender',
        default: false,
        description: 'Adds onContactFormRendered method to Helpcenter sdk',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17127'
    },
    TwitterTicket: {
        petriSpec: 'specs.TwitterTicket',
        default: false,
        description: 'Twitter Ticket',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17295'
    },
    FourMillionBar: {
        petriSpec: 'specs.FourMillionBar',
        default: false,
        description: '$4,000,000',
        mergeJira: 'never'
    },
    OneInboxTableV2: {
        petriSpec: 'specs.OneInboxTableV2',
        default: false,
        description: 'one inbox table layout v2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17326'
    },
    MultilevelFields: {
        petriSpec: 'specs.MultilevelFields',
        default: false,
        description: 'Multilevel Fields in the viewer side',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17286'
    },
    MultilevelFieldsSettings: {
        petriSpec: 'specs.MultilevelFieldsSettings',
        default: false,
        description: 'Multilevel Fields in the settings side',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17287'
    },
    TicketPageRefactor: {
        petriSpec: 'specs.TicketPageRefactor',
        default: false,
        description: 'Refactor Ticket page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17399',
    },
    SamlSsoLogin: {
        petriSpec: 'specs.SamlSsoLogin',
        default: false,
        description: 'Enables SAML SSO Login',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17393'
    },
    PreserveArticleEditorListIndentation: {
        petriSpec: 'specs.PreserveArticleEditorListIndentation',
        default: false,
        description: 'Preserves list indentation when copying lists between text blocks',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17339'
    },
    AutoRoutingSoundNotification: {
        petriSpec: 'specs.AutoRoutingSoundNotification',
        default: false,
        description: 'sound notification for auto routing',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17394'
    },
    CustomFieldsRouting: {
        petriSpec: 'specs.CustomFieldsRouting',
        default: false,
        description: 'Custom fields - Consolidate pages and add tabs',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17430'
    },
    TextEditorImagePluginRemoveBlockRenderer: {
        petriSpec: 'specs.TextEditorImagePluginRemoveBlockRenderer',
        default: false,
        description: 'Remove Block renderer for images in text editor (instead uses the decorator)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17444'
    },
    SpotterCSAT: {
        petriSpec: 'specs.SpotterCSAT',
        default: false,
        description: 'add new trigger for existing scenarios',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17461'
    },
    MultilevelFieldsUS10: {
        petriSpec: 'specs.MultilevelFieldsUS10',
        default: false,
        description: 'Case details section',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17479'
    },
    MacroVisiblePerGroupAgent: {
        petriSpec: 'specs.MacroVisiblePerGroupAgent',
        default: false,
        description: 'Add macro groups and agent restrictions',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17582'
    },
    TimelineEventsAgentModalEntryPoint: {
        petriSpec: 'specs.TimelineEventsAgentModalEntryPoint',
        default: false,
        description: 'adds the option to open the agent modal when clicking agent name in timeline events',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17528'
    },
    SchedulesP2: {
        petriSpec: 'specs.SchedulesP2',
        default: false,
        description: 'Schedules - multiple schedules',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17627'
    },
    MultilevelFieldsUS8: {
        petriSpec: 'specs.MultilevelFieldsUS8',
        default: false,
        description: 'Multilevel Fields - Macros & AA',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17631'
    },
    RuleEngineFacebookWhatsappSpecificIDs: {
        petriSpec: 'specs.RuleEngineFacebookWhatsappSpecificIDs',
        default: false,
        description: 'Allows automatic rule conditions to specify specific facebook and whatsapp IDs to operate on',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17694'
    },
    TwitterControlRoom: {
        petriSpec: 'specs.TwitterControlRoom',
        default: false,
        description: 'Twitter additions to control room',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17729'
    },
    TwitterTicketAlpha: {
        petriSpec: 'specs.TwitterTicketAlpha',
        default: false,
        description: 'Twitter features that are still in QA',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17739'
    },
    CsatConditions: {
        petriSpec: 'specs.CsatConditions',
        default: false,
        description: 'Adds CSAT conditions table to settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17715'
    },
    TwitterAutoRouting: {
        petriSpec: 'specs.TwitterAutoRouting',
        default: false,
        description: 'Twitter additions to auto routing',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17726'
    },
    MultiBrandsWidgetCustomDomain: {
        petriSpec: 'specs.MultiBrandsWidgetCustomDomain',
        default: false,
        description: 'Multi Brands Widget Side',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17727'
    },
};
//# sourceMappingURL=features.js.map